import React, { Fragment } from "react";
import { metaItConsulting } from "../../../../Utilites";
import MetaTagComponent from "../../../common/Meta/MetaTagComponent";
import ServiceDetailSection from "../../../services/ServiceDetailSection";
import {
  Box,
  Boxes,
  ChevronsLeftRightEllipsis,
  Clock,
  Code,
  CreditCard,
  DollarSign,
  Layout,
  MousePointerClick,
  Plug,
  Server,
  Settings,
  ShoppingBag,
  ShoppingCart,
  Smartphone,
  TrendingUp,
} from "lucide-react";

const ECommerceDevelopment = () => {
  const service = {
    slug: "ecommerce-development",
    title: "E-Commerce Development",
    description:
      "Comprehensive e-commerce solutions that drive sales and provide exceptional shopping experiences.",
    shortDescription:
      "Comprehensive e-commerce solutions for online businesses.",
    icon: ShoppingCart,
    gradient: "from-teal-500 to-blue-500",
    features: [
      "Custom E-commerce Platforms",
      "Payment Gateway Integration",
      "Inventory Management",
      "Order Processing Systems",
      "Mobile Commerce",
      "Multi-vendor Marketplaces",
    ],
    benefits: [
      "Increased Sales Revenue",
      "Better Customer Experience",
      "Automated Operations",
      "Global Market Reach",
    ],
    process: [
      "Business Requirements",
      "Platform Selection",
      "Custom Development",
      "Payment Integration",
      "Launch & Optimization",
    ],
    image:
      "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop",
  };

  const extension = {
    keyFeatures: [
      {
        name: "Custom E-Commerce Development",
        description:
          "Build tailored online stores designed to convert and scale",
        icon: ShoppingCart,
      },
      {
        name: "Platform Integration",
        description:
          "Seamless integration with platforms like Shopify, WooCommerce, and Magento",
        icon: Plug,
      },
      {
        name: "Mobile Commerce Optimization",
        description: "Responsive and fast-loading mobile shopping experiences",
        icon: Smartphone,
      },
      {
        name: "Payment Gateway Solutions",
        description: "Secure, multi-currency payment processing integration",
        icon: CreditCard,
      },
      {
        name: "Inventory & Order Management",
        description:
          "Real-time syncing across sales channels, warehouses, and CRM tools",
        icon: Boxes,
      },
      {
        name: "User Experience (UX) Design",
        description:
          "Conversion-focused design to enhance customer journey and retention",
        icon: Layout,
      },
    ],

    benefits: [
      {
        title: "Increased Online Sales",
        description:
          "Boost conversion rates with optimized design and functionality",
        icon: TrendingUp,
      },
      {
        title: "Seamless User Experience",
        description:
          "Deliver a smooth, mobile-friendly, and intuitive shopping journey",
        icon: MousePointerClick,
      },
      {
        title: "Faster Time to Market",
        description: "Launch your online store quickly with scalable solutions",
        icon: Clock,
      },
      {
        title: "Simplified Operations",
        description:
          "Automate inventory, order processing, and customer communication",
        icon: Settings,
      },
    ],

    process: [
      {
        step: "Business Discovery",
        description:
          "Understand your brand, goals, audience, and existing sales channels",
        duration: "1 Week",
      },
      {
        step: "Platform & Tech Stack Selection",
        description:
          "Choose the right platform and integrations for your store's needs",
        duration: "1 Week",
      },
      {
        step: "Design & Development",
        description:
          "Create responsive storefronts with custom features and secure checkout",
        duration: "3–5 Weeks",
      },
      {
        step: "Testing & QA",
        description:
          "Ensure performance, security, mobile responsiveness, and checkout flow",
        duration: "1–2 Weeks",
      },
      {
        step: "Launch & Post-Go-Live Support",
        description:
          "Deploy the store and provide support for optimization and scaling",
        duration: "Ongoing",
      },
    ],

    techStack: [
      { name: "Shopify", icon: ShoppingBag, category: "E-Commerce Platform" },
      {
        name: "WooCommerce",
        icon: ChevronsLeftRightEllipsis,
        category: "E-Commerce Plugin",
      },
      { name: "Magento", icon: Box, category: "E-Commerce Platform" },
      { name: "Stripe", icon: CreditCard, category: "Payment Gateway" },
      { name: "PayPal", icon: DollarSign, category: "Payment Gateway" },
      { name: "React / Next.js", icon: Code, category: "Frontend Framework" },
      { name: "Node.js", icon: Server, category: "Backend Framework" },
    ],
  };

  return (
    <Fragment>
      <MetaTagComponent metaDetails={metaItConsulting} />
      <ServiceDetailSection service={service} extension={extension} />
    </Fragment>
  );
};

export default ECommerceDevelopment;
